import Styled from "styled-components";
import { Button } from "@material-ui/core";

export default Styled(Button).attrs({
  variant: "contained"
})`
  && {
    color: white;
    text-transform: uppercase;
    font-size: 12px;
    width: ${props => (props.small ? "auto" : "150px")};
    border-radius: 0;
    @media (max-width: 380px) {
      width: 110px;
    }
  }
`;
